module.exports = __webpack_public_path__ + "img/exposure_plus_2.0e95fdd1.svg";